module.exports = __webpack_public_path__ + "img/company_intro1.d1221df2.jpg";